import { instance } from './axios'
import { notifyError } from '../services/logger'

export const fetchPosts = async (category = '', next = null) => {
  let url = category ? `/posts/${category}` : '/posts'
  url = next ? url + next : url
  return instance.get(url)
}

export const getPendings = async userId => {
  return instance.get(`/posts/pending/${userId}`)
}

export const getSummarized = async category => {
  return instance.get(`/posts/${category}/summarized`)
}

export const byUser = async (id, next = null) => {
  let url = `/posts/user/${id}`
  url = next ? url + next : url
  return instance.get(url)
}

export const getPost = async id => {
  try {
    const response = await instance.get(`/posts/${id}`)
    return {
      data: response,
    }
  } catch (error) {
    notifyError(error)
    throw new Error(error)
  }
}

export const createPost = async post => {
  return instance.post(`/posts`, post)
}

export const deletePost = async id => {
  return instance.delete(`/posts/${id}`)
}

export const postDeleteReason = async payload => {
  // TODO: change endpoint names
  return instance.post(`/postdeleted`, payload)
}

export const updatePost = async (id, payload) => {
  return instance.put(`/posts/${id}`, payload)
}

/**
 * The following methods are required for Apple policies
 */
export const blockPost = async payload => {
  // TODO: change endpoint names
  return instance.post('/postblocked', payload)
}

export const reportPost = async payload => {
  // TODO: change endpoint names
  return instance.post('/postDenuncied', payload)
}

export const blockUser = async payload => {
  // TODO: change endpoint names
  return instance.post('/userblocked', payload)
}

export const savePost = async payload => {
  const url = `/posts`
  return instance.post(url, payload)
}

export const savePostMedia = async payload => {
  const url = `/postmedia`
  return instance.post(url, payload)
}
